import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import TElogo from "../../../assets/images/logopng13.png";
import TElogo from "../../../../assets/images/dod_logo.png";
import { FaArrowLeft } from "react-icons/fa6";
import OTPInput from "react-otp-input";
import BtnLoader from "../../../components/Loader/btnLoader";
import { Toaster } from "../../../components/Toaster/Toster";
import { adminVerifyUserOtpApi } from "../../../../services/apis/AuthService";

function AdminFPVerifyOtp() {
  const location = useLocation()?.state;
  let errorsObj = { otp:"" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState();
  const [submitted, setSubmitted] = useState(false);
  // JSON.stringify(location?.otp)
  const [otp, setOtp] = useState("");
  const [btnLoading,setBtnLoading]=useState(false)
  const navigate = useNavigate();

  // Validation logic
  const validateFields = () => {
    const errorObj = { otp:"" };
    let isError = false;
    if (!otp) {
        errorObj.otp = 'OTP is required';
        isError = true;
      } else if (!/^\d{6}$/.test(otp)) {
        errorObj.otp = 'OTP must be a 6-digit number';
        isError = true;
      }
    setErrors(errorObj);
    return isError;
  };


  const onLogin = async(e)=> {
    e.preventDefault();
    setSubmitted(true);
    // Validate fields
    if (validateFields()) {
      return;
    }
    setBtnLoading(true);
    const formData={
      email:location?.email ? location?.email :"",
      otp:otp
    }
    
    try {
      const res = await adminVerifyUserOtpApi(formData);
       console.log("resss",res)
       const resData = res?.data
       const stateData={
        email:location?.email,
       }

      if (resData?.success) {
        navigate("/change-password", {state:stateData});
        // Toaster.success(res?.data?.message);
      }
    } catch (error) {
      console.log("errrrr",error)
      Toaster.error(error.response?.data?.message);
    } finally {
      setBtnLoading(false);
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="fix-wrapper py-0">
        <div className="w-100">
          <div className="row login-mainsection-background">
            <div className="col-12 col-lg-12 login-right-section d-flex flex-column justify-content-center">
              <div className=" login-right-content-section">
                <div className="card login-card mb-0 h-auto">
                  <div className="card-body">
                    {/* logo */}
                    <div className="d-flex justify-content-center mb-2">
                      <Link to={"/user/login"}>
                        <img
                          src={TElogo}
                          alt="logo"
                          style={{ height: "80px", width: "auto" }}
                        />
                      </Link>
                    </div>
                    {/* Tag or intro Line */}
                    <h4 className="login-welcome-text">Verify Otp</h4>
                    <p className="mb-4 fs-5 text-dark">Please confirm your account by entering the authorization code
                    send to <b>{location?.email}</b> it will expire in <b>6 minutes</b>.</p>
                    {/* <p className="mb-3 text-black">Enter the 6 digit varification otp that was sent to your email address.</p> */}
                    {/* Form */}
                    <form onSubmit={onLogin}>
                    <div className="mb-3">
                      <label className="mb-1 text-dark">
                        {/* <strong>OTP</strong> */}
                      </label>
                      <OTPInput
                        containerStyle={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          maxWidth: '400px',
                          margin: '0 auto',
                        }}
                        inputStyle="otp-input-style"
                        inputType="number"
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderSeparator={<span className="text-white">-</span>}
                        renderInput={(props) => <input {...props} />}
                      />
                      {errors.otp && (
                        <div className="text-danger fs-12 mt-2">
                          {errors.otp}
                        </div>
                      )}
                    </div>
                      
                      <div className="">
                        <button
                          type="submit"
                          className="btn text-white btn-block handle-login-btn">
                          {btnLoading && <BtnLoader/> } Submit
                        </button>

                        <button
                          type="submit"
                          className="btn text-black mt-3 px-0"
                          onClick={()=>navigate(-1)}>
                           <FaArrowLeft/> Go back
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminFPVerifyOtp;
